import { render, staticRenderFns } from "./btn-outline-loading.mpx?vue&type=template&id=31030b28&isComponent&outputPath=components%2Fbtn-outline-loading212480f4%2Findex"
import script from "./btn-outline-loading.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-outline-loading212480f4%2Findex"
export * from "./btn-outline-loading.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-outline-loading212480f4%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports